<template>
	<div v-if="currentPostType === 'events' && currentPage.acf" class="event-dates-info">
		<div class="inner-meta">
			<WpImage
				:image="currentPage.featured_image"
				size="extra_large"
				class="featured-image-page"
				background
				:radius="false"
				cover
			/>
			<div class="event-info font-size--26">
				<div class="informations">
					<div v-if="currentPage.acf.type" class="line taxonomy">
						{{ currentPage.acf.type.name }}
					</div>
					<div v-if="organizator" class="line organizator">by {{ organizator }}</div>
					<div class="line timing">
						<span v-if="eventDatetime" class="date">
							{{ eventDatetime.format('DD.MM.YYYY') }}
						</span>
						<span
							v-if="
								eventDatetimeEnd &&
								eventDatetime.format('DD.MM.YYYY') !== eventDatetimeEnd.format('DD.MM.YYYY')
							"
							class="date date-end"
						>
							- {{ eventDatetimeEnd.format('DD.MM.YYYY') }}
						</span>
						<span v-if="displayTime && !eventDatetimeEnd" class="time">at {{ displayTime }}</span>
					</div>
					<div v-if="currentPage.acf.org_info" class="line org-info">
						{{ currentPage.acf.org_info }}
					</div>
				</div>
				<div
					class="sigup"
					v-if="!currentPage.acf.signup_is_closed && currentPage.acf.signup_type !== 'none' && stillCanSignup"
				>
					<Button
						@click.native="internalSignup"
						:theme="buttonTheme"
						v-if="currentPage.acf.signup_type === 'internal'"
						icon="arrowRight"
						button
					>
						Sign up
					</Button>
					<Button
						target="_blank"
						rel="nofollow noopener"
						:theme="buttonTheme"
						v-if="currentPage.acf.external_url && currentPage.acf.signup_type === 'external'"
						:url="currentPage.acf.external_url"
						icon="arrowRight"
					>
						Sign up
					</Button>
				</div>

				<span class="icon-event" v-html="iconType(currentPage.acf.category)"></span>
			</div>
		</div>
	</div>
</template>

<script>
import moment from 'moment'
moment.locale('nb-NO')
import WpImage from '@/components/elements/WpImage'
import Button from '@/components/elements/Button'
import { system, fish, leaft, gear, heartch } from '@/icons'
import { mapGetters, mapMutations } from 'vuex'

export default {
	data() {
		return {
			eventDatetime: '',
			eventDatetimeEnd: '',
		}
	},
	components: {
		WpImage,
		Button,
	},
	computed: {
		...mapGetters(['currentPage', 'currentPostType']),
		buttonTheme() {
			return this.currentPage.acf.category === 'default' ? 'dark' : this.currentPage.acf.category
		},
		organizator() {
			if (this.currentPage.acf.org_type === 'external') return this.currentPage.acf.org_name
			if (this.currentPage.acf.org_type === 'internal') return 'The Life Science Cluster'
			return ''
		},
		stillCanSignup() {
			const now = moment()
			let end = this.eventDatetimeEnd || this.eventDatetime
			// Helpers.
			// console.log(end.format('DD.MM.YYYY'))
			// console.log(now.format('DD.MM.YYYY'))
			// console.log(end.isAfter(now))
			// https://stackoverflow.com/questions/29494528/how-to-compare-only-date-in-moment-js.
			return true // now.isAfter(end)
		},
		displayTime() {
			const startTime = this.currentPage.acf.time_from || ''
			const endTime = this.currentPage.acf.time_to || ''

			const startTimeNumber = startTime ? Number(startTime.replaceAll(':', '')) : ''
			const endTimeNumber = endTime ? Number(endTime.replaceAll(':', '')) : ''

			if (startTimeNumber < endTimeNumber && endTimeNumber) {
				return startTime.substr(0, 5) + ' - ' + endTime.substr(0, 5)
			} else if (endTimeNumber && startTimeNumber === endTimeNumber) {
				return startTime.substr(0, 5)
			} else {
				return startTime.substr(0, 5)
			}
		},
	},
	created() {
		this.eventDatetime = this.currentPage.acf.event_datetime ? moment(this.currentPage.acf.event_datetime) : false
		this.eventDatetimeEnd = this.currentPage.acf.event_datetime_copy
			? moment(this.currentPage.acf.event_datetime_copy)
			: false
	},
	methods: {
		...mapMutations(['SINGUP_MODAL_CHANGE_STATE']),
		internalSignup() {
			this.SINGUP_MODAL_CHANGE_STATE()
		},
		iconType(type) {
			switch (type) {
				case 'blue':
					return fish()
					break
				case 'red':
					return heartch()
					break
				case 'green':
					return leaft()
					break
				case 'purple':
					return gear()
					break
				default:
					return system()
					break
			}
		},
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';
body {
	&.theme-dark {
		.event-info {
			background-color: var(--gray);
			color: var(--dark);
		}
	}
	&.theme-blue {
		.event-info {
			background-color: var(--blueLight);
			color: var(--blue);
		}
	}
	&.theme-green {
		.event-info {
			background-color: var(--greenLight);
			color: var(--green);
		}
	}
	&.theme-red {
		.event-info {
			background-color: var(--redLight);
			color: var(--red);
		}
	}
	&.theme-purple {
		.event-info {
			background-color: var(--purpleLight);
			color: var(--purple);
		}
	}
}
.event-dates-info {
	.inner-meta {
		display: flex;
		width: 100%;
		@include mquery($phone) {
			flex-direction: column;
		}
	}
	.wp-image-vue,
	.event-info {
		min-width: 50%;
		max-width: 50%;
		@include mquery($phone) {
			max-width: 100%;
			min-width: 100%;
		}
	}

	.event-info {
		border-top-right-radius: $radius;
		border-bottom-right-radius: $radius;
		background-color: var(--gray);
		padding: 50px;
		min-height: 350px;
		position: relative;
		display: flex;
		flex-direction: column;
		@include mquery($tablet) {
			padding: 30px;
		}

		@include mquery($phone) {
			padding: 20px;
			min-height: 250px;
			border-top-right-radius: 0;
			border-bottom-left-radius: $radius;
		}

		.informations {
			flex-grow: 1;
			.line {
				margin-bottom: 10px;
			}
		}
	}
	.sigup {
		margin-top: 25px;
		@include mquery($phone) {
			margin-top: 15px;
		}
	}
	.icon-event {
		position: absolute;
		top: 50px;
		right: 50px;
		@include mquery($tablet) {
			top: 30px;
			right: 30px;
		}
		@include mquery($phone) {
			top: 20px;
			right: 20px;
		}
		svg {
			width: 50px;
			height: 50px;
		}
	}

	.wp-image-vue div.image {
		border-top-left-radius: $radius;
		border-bottom-left-radius: $radius;
		height: 100%;
		padding: 0;
		@include mquery($phone) {
			padding-bottom: 56.25%;
			height: 0;
			border-top-right-radius: $radius;
			border-top-left-radius: 0;
		}
	}
}
</style>
